module.exports = __webpack_public_path__ + "static/media/table_prestasi.6ed09cc6.png";